export const fdefSchadenEdit = {
  formdefinition: [
    /* {
      control: "accordion",
      name: "eckdaten",
      label: "Eckdaten",
      valid: "isSubFormValid(item)",
      children: [
        {
          control: "input",
          name: "sparte",
          label: "Sparte",
          cols: "12",
          disabled: "true",
        },
        {
          control: "datepicker",
          name: "schaden_datum",
          label: "Schadendatum",
          valid: "isNotEmpty(item)",
          cols: "63",
        },
      ],
    },
    {
      control: "accordion",
      name: "nummern",
      label: "Nummern",
      valid: "isSubFormValid(item)",
      children: [*/
    {
      control: "input",
      name: "schaden_nummer_kd",
      label: "Vorgangsnummer (Kunde)",
      cols: "12",
    },
    {
      control: "input",
      name: "schaden_nummer_vu",
      label: "Schadennr. VU",
      cols: "12",
    },
    /* ],
    },
    {
      control: "accordion",
      name: "adresse",
      label: "Adresse",
      valid: "isSubFormValid(item)",
      children: [
        {
          control: "input",
          name: "schaden_strasse",
          label: "Strasse",
          cols: "12",
        },

        {
          control: "input",
          name: "schaden_plz",
          label: "PLZ",
          cols: "12",
        },

        {
          control: "input",
          name: "schaden_ort",
          label: "Ort",
          cols: "12",
        },

        {
          control: "input",
          name: "schaden_land",
          label: "Land",
          cols: "12",
        },

        {
          control: "input",
          name: "schaden_bundesland",
          label: "Bundesland",
          cols: "12",
        },
      ],
    },
*/
    {
      control: "numberinput",
      name: "auszahlungsbetrag",
      label: "Auszahlungsbetrag",
      unit_type: "currency",
      unit: "€",
      cols: "12",
    },
    // {
    //   control: "select",
    //   name: "detail_status",
    //   label: "Status",
    //   cols: "12",
    //   options: [
    //     { key: "gespeichert", label: "gespeichert" },
    //     { key: "Korrektur erforderlich", label: "Korrektur erforderlich" },
    //     { key: "Prüfung", label: "Prüfung" },
    //     { key: "gemeldet", label: "gemeldet" },
    //     { key: "reguliert", label: "reguliert" },
    //     {
    //       key: "geschlossen (unterhalb SB)",
    //       label: "geschlossen (unterhalb SB)",
    //     },
    //     { key: "geschlossen", label: "geschlossen" },
    //     { key: "abgelehnt", label: "abgelehnt" },
    //   ],
    // },
  ],
  transformOut: [],
};
